export default "__VITE_ASSET__1988e7bf__"